/** Shared title extraction for calendar schedule rows. */
export function extractEventTitle(event: {
  title?: string;
  description?: {
    short_description?: Record<string, { translation_text?: string }>;
    long_description?: Record<string, { translation_text?: string }>;
  };
}): string {
  if (event.title?.trim()) {
    return event.title.trim();
  }
  const desc = event.description;
  if (!desc) {
    return 'Begivenhed';
  }
  const fromBlock = (block?: Record<string, { translation_text?: string }>): string | null => {
    if (!block) return null;
    if (block['da']?.translation_text) return block['da'].translation_text;
    if (block['en']?.translation_text) return block['en'].translation_text;
    for (const key of Object.keys(block)) {
      const t = block[key]?.translation_text;
      if (t) return t;
    }
    return null;
  };
  const short = fromBlock(desc.short_description);
  if (short) return short;
  const long = fromBlock(desc.long_description);
  if (long) return long;
  return 'Begivenhed';
}
